/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "./AuthHelpers";

//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const CHEF_VIEW = process.env.REACT_APP_SOCKET_URL;
const ChefPortal_Settings =`${CHEF_VIEW}/v1/chefportal-settings/`
//VERIFY EMAIL
export function verifyEmail(email: string, emailOtp: string) {
  return axios.post(`${API_URL}verify-otp-email`, { email, emailOtp });
}
export const getChefPortalSettings = async () => {
  const response = await axios.post(`${ChefPortal_Settings}view`, getToken());
  return response.data;
};

//VERIFY TOKEN
export function getUserByToken(token: any) {
  return axios.post(`${API_URL}verify-token`, {
    token: token,
  });
}

//REGISTER
const chefRegisteration = async (data: any) => {
  const response = await axios.post(`${API_URL}chef-app-sign-up`, data);

  return response.data;
};
//social register
const chefSocialRegisteration = async (data: any) => {
  const response = await axios.post(`${API_URL}social-signUp`, data);

  return response.data;
};
const SocialSignupLoginVerification = async (data: any) => {
  const response = await axios.post(
    `${API_URL}chef-app-verify-social-account`,
    data
  );

  return response?.data;
};

const verifyChefEmail = async (data: any) => {
  const response = await axios.post(`${API_URL}chef-app-verify-otp`, data);
  return response.data;
};

const login = async (requestData: any) => {
  const response = await axios.post(`${API_URL}login`, requestData);

  return response.data;
};

const forgotPasswordMail = async (email: any) => {
  const response = await axios.post(`${API_URL}forgot-password-send-mail`, {
    email,
  });
  return response.data;
};

const decryptData = async (userData: any) => {
  const response = await axios.post(`${API_URL}decrypt-data`, getToken(), {
    data: userData,
  });
  return response.data;
};

const callGooglePlacesApi = async (address: any) => {
  const response = await axios.get(`${API_URL}fetch-location?input=${address}`);
  return response.data;
};

const locationLatLongAPIFetch = async (place_id: any) => {
  const response = await axios.get(
    `${API_URL}fetch-location-latLong?input=${place_id}`
  );
  return response.data;
};

const mostOrerDish = async (id: any) => {
  return await axios
    .get(`${API_URL}most-order-dish/${id}`, getToken())
    .then((response) => {
      return response.data.data;
    });
};

const topRatedDish = async (id: any) => {
  return await axios
    .get(`${API_URL}top-rated-dish/${id}`, getToken())
    .then((response) => {
      return response.data.data;
    });
};

const recentReview = async (id: any) => {
  return await axios
    .get(`${API_URL}recent-chef-reviews/${id}`, getToken())
    .then((response) => {
      return response.data.data;
    });
};

const graphData = async (id: any) => {
  return await axios
    .get(`${API_URL}graph/${id}`, getToken())
    .then((response) => {
      return response.data;
    });
};

const listOrdersData = async (ChefId: any) => {
  const response = await axios.get(
    `${API_URL}list-order/${ChefId}`,
    getToken()
  );
  return response.data.data;
};

const totalNetValue = async (ChefId: any) => {
  const response = await axios.get(`${API_URL}net-value/${ChefId}`, getToken());
  return response.data;
};

const getNotification = async (ChefId: any) => {
  const response = await axios.get(
    `${API_URL}get-notification/${ChefId}`,
    getToken()
  );

  return response.data.data;
};

const clearNotification = async (ChefId: any) => {
  const response = await axios.delete(
    `${API_URL}clear-notification/${ChefId}`,
    getToken()
  );
  return response.data.data;
};
const ProfileDetails = async (chefId: any) => {
  const response = await axios.get(`${API_URL}view-chef/${chefId}`);
  
  return response.data;
};
const settingsDetails = async (id: any) => {
  const response = await axios.get(`${API_URL}view-information/${id}`);
  
  return response.data;
};

const addressUserFetch = async (data: any) => {
  const response = await axios.post(
    `${API_URL}fetch-address`,
    data,
    getToken()
  );

  return response.data.data;
};

const currentlyAvailable = async (id: any, currentlyAvailableStatus: any) => {
  const response = await axios.put(
    `${API_URL}available-chef/${id}`,
    currentlyAvailableStatus,
    getToken()
  );
  return response.data;
};

const sendEmailOtp = async (data: any) => {
  return await axios
    .post(`${API_URL}resend-otp-email`, data)
    .then((response) => {
      return response.data;
    });
};

const sendOtpData = async (data: any) => {
  
  return await axios
    .post(`${API_URL}chef-app-send-otp`, data)
    .then((response) => {
      
      
      return response.data;
    });
};

const sendMobileOtp = async (data: any) => {
  return await axios
    .post(`${API_URL}resend-otp-mobile`, data)
    .then((response) => {
      return response.data;
    });
};

const verifyChefMobile = async (data: any) => {
  const response = await axios.post(`${API_URL}chef-app-verify-otp`, data);
  return response.data;
};
const searching = async (ChefId: any, searchTerm: string) => {
  const response = await axios.post(
    `${API_URL}hard-search/${ChefId}?search=${searchTerm}`,
    getToken()
  );

  return response.data;
};
const changeStatusOrders = async (id: any, orderStatus: any) => {
  const res = await axios.post(
    `${API_URL}change-order-status/${id}`,
    orderStatus
  );

  return res.data;
};
const BasicSettingsDetails = async () => {
  const response = await axios.get(`${API_URL}get-basic-settings`);
  return response.data;
};
const deleteNotificationToken = async (data: any) => {
  const response = await axios.post(
    `${API_URL}delete-web-token`,
    data,
    getToken()
  );
  return response.data;
};
const checkDuplicateEmail = async (email: any) => {
  const response = await axios.post(
    `${API_URL}find-duplicate-email-mobile-signup`,
    { email }
  );

  return response.data;
};
const checkDuplicateMobile = async (
  mobileNumber: any,
  signupType: any,
  chefuuid: any
) => {
  const response = await axios.post(
    `${API_URL}find-duplicate-email-mobile-signup`,
    { mobileNumber, signupType, chefuuid }
  );
  //
  return response.data;
};
const sendOtpCommonMobile = async (data: any) => {
  return await axios
    .post(`${API_URL}send-otp-common`, data)
    .then((response) => {
      return response.data;
    });
};
const verifyOtpCommonMobile = async (mobileNumber: any, otp: any) => {
  const response = await axios.post(`${API_URL}verify-otp-common`, {
    mobileNumber,
    otp,
  });
  return response.data;
};

const viewApp = async (id: any) => {
  return await axios
    .get(`${API_URL}app-settings/${id}`, getToken())
    .then((response) => {
      return response.data;
    });
};
export const saveDeviceToken = async (tokenData: any) => {
  const response = await axios.post(
    `${API_URL}save-token`,
    tokenData,
    getToken()
  );
};
export {
  checkDuplicateEmail,
  sendOtpCommonMobile,
  verifyOtpCommonMobile,
  checkDuplicateMobile,
  decryptData,
  ProfileDetails,
  verifyChefMobile,
  sendMobileOtp,
  chefRegisteration,
  chefSocialRegisteration,
  SocialSignupLoginVerification,
  verifyChefEmail,
  login,
  callGooglePlacesApi,
  locationLatLongAPIFetch,
  mostOrerDish,
  topRatedDish,
  recentReview,
  graphData,
  listOrdersData,
  totalNetValue,
  getNotification,
  clearNotification,
  addressUserFetch,
  currentlyAvailable,
  forgotPasswordMail,
  sendEmailOtp,
  sendOtpData,
  searching,
  changeStatusOrders,
  BasicSettingsDetails,
  deleteNotificationToken,
  viewApp,
  settingsDetails,
};
